/* import __COLOCATED_TEMPLATE__ from './data-connector-call-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationDataConnectorCall } from '../conversation-item';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

export interface ConversationArgs {
  conversationItem: FormattedConversationDataConnectorCall;
  verboseLogsEnabled: boolean;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class DataConnectorCallConversationItem extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked isExpanded = false;

  get formattedLoadingText() {
    return this.intl.t(
      'ai-agent.voice-playground.conversation.data-connector-call.action-in-progress',
      { actionName: this.args.conversationItem.actionName },
    );
  }

  get formattedActionName() {
    return this.intl.t('ai-agent.voice-playground.conversation.data-connector-call.action-called', {
      actionName: this.args.conversationItem.actionName,
    });
  }

  get formattedResult() {
    let { resultStatus, resultError } = this.args.conversationItem;

    if (resultStatus === 'error') {
      return this.intl.t(
        'ai-agent.voice-playground.conversation.data-connector-call.result-error',
        {
          error:
            resultError ??
            this.intl.t('ai-agent.voice-playground.conversation.data-connector-call.unknown-error'),
        },
      );
    }

    return this.intl.t('ai-agent.voice-playground.conversation.data-connector-call.result-ok');
  }

  get formattedRequestParams() {
    return JSON.stringify(this.args.conversationItem.requestParams ?? {}, null, 2);
  }

  get formattedResultUpdates() {
    return JSON.stringify(this.args.conversationItem.resultUpdates ?? {}, null, 2);
  }

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::DataConnectorCallConversationItem': typeof DataConnectorCallConversationItem;
  }
}
